import { useRef } from "react";
import {
  Typography,
  Box,
  Button,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Chip,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useMedia } from "../context/MediaContext";
import { useTheme } from "@mui/material";
const mainColor = "#635BFF";
const lightColor = "rgba(99, 91, 255, 0.1)";

// Тип для одного мерчанта
type Merchant = {
  id: number;
  name: string;
};

// Пропсы компонента
interface ChoosingMerchantsProps {
  forwardMerch: number[];
  setForwardMerch: React.Dispatch<React.SetStateAction<number[]>>;
  merchants: Merchant[];
  setSelectedMerch: any;
  setForwardedSumm: any;
  selectedSumm: any;
}

const ChoosingMerchants: React.FC<ChoosingMerchantsProps> = ({
  forwardMerch,
  setForwardMerch,
  merchants,
}) => {
  const selectRef = useRef<HTMLDivElement | null>(null);
  const { isMobile600, isTablet } = useMedia();
  const theme = useTheme();
  return (
    <Box width={isTablet ? "100%" : "35%"} margin={isTablet ? "0 auto" : 0}>
      <FormControl
        fullWidth
        sx={{
          position: "relative",
        }}
      >
        <InputLabel
          shrink={false}
          sx={{
            position: "absolute",
            top: "40%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            pointerEvents: "none",
            fontSize: isMobile600 ? "16px" : "18px",
            zIndex: 1,
            display: forwardMerch.length === 0 ? "block" : "none",
          }}
        >
          Выберите мерчанта
        </InputLabel>

        <Select
          ref={selectRef}
          MenuProps={{
            disableScrollLock: true,
            slotProps: {
              paper: {
                sx: {
                  borderRadius: "12px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                  overflow: "auto",

                  scrollbarWidth: "none",
                  "&::-webkit-scrollbar": {
                    width: 0,
                    height: 0,
                  },
                },
              },
            },
          }}
          sx={{
            width: "100%",
            maxWidth: isTablet ? "100%" : "440px",
            minWidth: 0,
            overflow: "hidden",
            "&::-webkit-scrollbar": { display: "none" },

            borderRadius: "12px",

            "& .MuiOutlinedInput-notchedOutline": {
              borderColor:
                forwardMerch.length !== 0 ? mainColor : "rgba(0,0,0,0.2)",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: mainColor,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: mainColor,
              borderWidth: "2px",
            },
            minHeight: "81px",
          }}
          multiple
          value={forwardMerch}
          onChange={(e) => {
            const {
              target: { value },
            } = e;
            setForwardMerch(
              typeof value === "string"
                ? value.split(",").map((v) => Number(v))
                : value,
            );
          }}
          renderValue={(selected) => (
            <Box
              onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => {
                const target = e.target as HTMLElement;
                if (target.scrollWidth > target.clientWidth) {
                  e.stopPropagation();
                }
              }}
              sx={{
                display: "flex",
                gap: 0.5,
                overflowX: "auto",
                whiteSpace: "nowrap",
                "&::-webkit-scrollbar": { display: "none" },
                scrollbarHeight: "thin",
              }}
            >
              {selected.map((id) => {
                const merch = merchants.find((el) => el.id === id);
                return (
                  <Chip
                    key={id}
                    label={merch?.name}
                    sx={{
                      backgroundColor: mainColor,
                      color: "white",
                      borderRadius: "12px",
                      fontWeight: "600",
                      "& .MuiChip-icon": { color: "white" },
                    }}
                  />
                );
              })}
            </Box>
          )}
        >
          {merchants.map((el) => (
            <MenuItem
              key={el.id}
              value={el.id}
              sx={{
                p: 1.5,
                display: "flex",
                alignItems: "center",
                gap: 1,
                borderBottom: "1px solid rgba(0,0,0,0.05)",
                "&:last-child": { borderBottom: "none" },
                backgroundColor: forwardMerch.includes(el.id)
                  ? lightColor
                  : "transparent",
                transition: "0.3s",
                "&:hover": {
                  backgroundColor: lightColor,
                },
              }}
            >
              <CheckCircleIcon
                color={forwardMerch.includes(el.id) ? "primary" : "disabled"}
              />
              <Typography
                fontSize={isMobile600 ? "14px" : "16px"}
                fontWeight={500}
              >
                {el.name}
              </Typography>
            </MenuItem>
          ))}
        </Select>

        <Button
          onClick={() => {
            if (forwardMerch.length === merchants.length) {
              setForwardMerch([]);
            } else setForwardMerch(merchants.map((el) => el.id));
          }}
          variant="outlined"
          size="small"
          sx={{
            backgroundColor: "rgba(0, 0, 0, 0.08)",
            borderRadius: "20px",
            width: "100%",
            textTransform: "none",
            fontSize: "0.8rem",
            px: 2,
            color: theme.palette.text.primary,

            borderColor: "divider",
            "&:hover": {
              color: theme.palette.primary.main,
              borderColor: theme.palette.primary.main,
            },
          }}
        >
          {forwardMerch.length === merchants.length
            ? "Убрать все"
            : "Выбрать все"}
        </Button>
      </FormControl>
    </Box>
  );
};

export default ChoosingMerchants;
